import { render, staticRenderFns } from "./CrmTicket.vue?vue&type=template&id=5ceff872&scoped=true"
import script from "./CrmTicket.vue?vue&type=script&lang=js"
export * from "./CrmTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceff872",
  null
  
)

export default component.exports